import { LinkItem } from "../models/main/link-item.model";
import { Policies } from "../models/main/policies.enum";

/**
 * Menú principal de navegación compartido entre todas las páginas principales
 */
export const HOME_MENU_ITEMS: LinkItem[] = [
	{
		text: "header.menu.opportunities",
		url: "/opportunities",
		active: true,
		policies: [],
	},
	{
		text: "header.menu.home",
		url: "/home",
		active: true,
		policies: [],
	},
	// {
	// 	text: "header.menu.cebes",
	// 	url: "/cebes",
	// 	active: true,
	// 	policies: [],
	// },
	{
		text: "header.menu.sites",
		url: "/map",
		active: true,
		policies: [],
	},

	{
		text: "header.menu.contacts",
		url: "/contacts",
		active: true,
		policies: [],
	},
	{
		text: "header.menu.powerbi",
		url: "/powerbi",
		active: true,
		policies: [Policies.Admin],
	},
];

/**
 * Función helper para obtener una copia del menú con configuraciones específicas
 */
export function getHomeMenuWithVisited(visitedPath: string): LinkItem[] {
	return HOME_MENU_ITEMS.map((item) => ({
		...item,
		visited: item.url === visitedPath,
	}));
}

/**
 * Función helper para obtener una copia del menú básico
 */
export function getHomeMenu(): LinkItem[] {
	return [...HOME_MENU_ITEMS];
}
